import React from 'react';
import { IconS24CheckmarkCircle48Filled, IconS24ErrorCircle48 } from '@is24/cosma-ui-icons';
import { EmptyState } from 'is24-corecss';
import { useTranslation } from 'react-i18next';
import './WebIdMobileResultPage.css';

interface WebIdMobileResultPageProps {
  status: 'success' | 'failure';
}

const WebIdMobileResultPage: React.FC<WebIdMobileResultPageProps> = ({ status }) => {
  const { t } = useTranslation();
  const isSuccess = status === 'success';
  const ResultIcon = isSuccess ? IconS24CheckmarkCircle48Filled : IconS24ErrorCircle48;
  const resultKey = isSuccess ? 'success' : 'failure';
  return (
    <main className='webid-result-page'>
      <section className='webid-result-card' aria-label={t(`WebIdMobileResultPage.${resultKey}Title`)}>
        <div className='webid-result-card-label font-body-small-bold'>{t('WebIdMobileResultPage.label')}</div>
        <EmptyState.Root className='webid-result-empty-state' size='large'>
          <EmptyState.Image decorative>
            <ResultIcon aria-hidden='true' height={64} width={64} />
          </EmptyState.Image>
          <EmptyState.Body>
            <EmptyState.Title>{t(`WebIdMobileResultPage.${resultKey}Title`)}</EmptyState.Title>
            <EmptyState.Description>{t(`WebIdMobileResultPage.${resultKey}Description`)}</EmptyState.Description>
          </EmptyState.Body>
        </EmptyState.Root>
      </section>
    </main>
  );
};

export default WebIdMobileResultPage;
